import { Box } from '@chakra-ui/react';
import moment from 'moment';
import { upperCase } from 'lodash';
import { useTranslation } from 'react-i18next';

import { TextBold, TextRegular } from 'UiKit/typography';
import { Condition, Iteration } from 'Component/others';

import { nameOfDays, weeks } from 'View/schedule-generate/const';
import getTimezoneLabel from 'View/schedule-generate/helper/getTimezoneLabel';
import checkIsEventDay from 'View/schedule-generate/helper/checkIsEventDay';
import { useScheduleGenerateState } from 'View/schedule-generate/state';

import styles from './styles.module.css';

const CalendarDay = ({ showWeek, weekInfo }) => {
  const timezoneLabel = getTimezoneLabel();
  const { i18n } = useTranslation('schedule-generate');
  const { generateResultData } = useScheduleGenerateState();
  const { metadata } = generateResultData;
  const selectedYearMonth = metadata?.yearMonth;

  const anchorYear = parseInt(selectedYearMonth?.slice(0, 4));
  const anchorMonthIdx = parseInt(selectedYearMonth?.slice(5, 7)) - 1; // 0-indexed
  const overflowMonthIdx = anchorMonthIdx + 1;
  const overflowMonthYear = overflowMonthIdx > 11 ? anchorYear + 1 : anchorYear;
  const wrappedOverflowMonthIdx = overflowMonthIdx > 11 ? 0 : overflowMonthIdx;

  return (
    <Box className={styles['calendar__section--head']}>
      <Box className={styles['calendar__column--timezone']}>
        <TextRegular className={styles['calendar__text--timezone']}>{timezoneLabel}</TextRegular>
      </Box>

      <Box className={styles['calendar__column--days']}>
        <Iteration
          items={weeks}
          render={(week, index) => {
            const firstRowDayOfWeek = (15 + (weekInfo?.firstDayOfTheMonth ?? 0)) % 7;
            const indexOfDays = (index + firstRowDayOfWeek) % 7;
            const day = (showWeek - 1) * 7 + week + 15;
            const isDayInMonth = day <= weekInfo?.lastDate;
            const date = isDayInMonth ? day : day - weekInfo?.lastDate;
            const isInsidePeriod = (isDayInMonth && date >= 16) || (!isDayInMonth && date <= 15);
            const badge = checkIsEventDay(metadata, date);

            const cellYear = isDayInMonth ? anchorYear : overflowMonthYear;
            const cellMonthIdx = isDayInMonth ? anchorMonthIdx : wrappedOverflowMonthIdx;
            const monthLabel = !Number.isNaN(cellYear)
              ? upperCase(moment({ year: cellYear, month: cellMonthIdx, day: 1 }).locale(i18n.language).format('MMM'))
              : '';

            return (
              <Box
                className={`${styles['calendar__column--day']} ${!isInsidePeriod && styles['calendar__column--day-disabled']}`}
                title={!isInsidePeriod ? monthLabel : undefined}
              >
                {/* Date + month (e.g. "16 Agt") so each cell is unambiguous. */}
                <TextBold className={styles['calendar__text--date']}>
                  {date} {monthLabel}
                </TextBold>
                {/* Day of week (e.g. "RAB") */}
                <TextRegular className={styles['calendar__text--day']}>{nameOfDays[indexOfDays]}</TextRegular>

                {/* Badge */}
                <Condition statement={badge !== null && isInsidePeriod}>
                  <Box className={styles['calendar__container--badge']} bgColor={badge?.bgColor}>
                    <TextBold className={styles['calendar__text--badge']}>{badge?.text}</TextBold>
                  </Box>
                </Condition>
              </Box>
            );
          }}
        />
      </Box>
    </Box>
  );
};

export default CalendarDay;
